/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { EmployeeMessage } from './EmployeeMessage';
import {
    EmployeeMessageFromJSON,
    EmployeeMessageFromJSONTyped,
    EmployeeMessageToJSON,
    EmployeeMessageToJSONTyped,
} from './EmployeeMessage';

/**
 * 
 * @export
 * @interface ListEmployeeMessagesResponse
 */
export interface ListEmployeeMessagesResponse {
    /**
     * 
     * @type {Array<EmployeeMessage>}
     * @memberof ListEmployeeMessagesResponse
     */
    data: Array<EmployeeMessage>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEmployeeMessagesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListEmployeeMessagesResponse interface.
 */
export function instanceOfListEmployeeMessagesResponse(value: object): value is ListEmployeeMessagesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEmployeeMessagesResponseFromJSON(json: any): ListEmployeeMessagesResponse {
    return ListEmployeeMessagesResponseFromJSONTyped(json, false);
}

export function ListEmployeeMessagesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmployeeMessagesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeeMessageFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEmployeeMessagesResponseToJSON(json: any): ListEmployeeMessagesResponse {
      return ListEmployeeMessagesResponseToJSONTyped(json, false);
  }

  export function ListEmployeeMessagesResponseToJSONTyped(value?: ListEmployeeMessagesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeeMessageToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

